import React, { useState } from "react";
import { useCart } from "react-use-cart";
import Cart from "./Cart";

const CartFloatButton = () => {
  const { items, totalUniqueItems, emptyCart } = useCart();
  const [showCart, setShowCart] = useState(false);

  if (items.length === 0) return null;

  return (
    <>
      <button
        className="cart-float-btn"
        onClick={() => setShowCart(true)}
        title="Lihat Keranjang"
      >
        <i className="bi bi-bag"></i>
        <span className="cart-float-badge">{totalUniqueItems}</span>
      </button>

      {showCart && (
        <Cart emptyCart={emptyCart} onClose={() => setShowCart(false)} />
      )}

      <style>{`
        .cart-float-btn {
          position: fixed;
          bottom: 24px;
          left: 24px;
          z-index: 999;
          background: #e51d2a;
          color: white;
          border: none;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(229,29,42,0.35);
          cursor: pointer;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .cart-float-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 12px 35px rgba(229,29,42,0.4);
        }
        .cart-float-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #111;
          color: white;
          border-radius: 50%;
          width: 22px;
          height: 22px;
          font-size: 12px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </>
  );
};

export default CartFloatButton;
